// extracted by mini-css-extract-plugin
export default {"carousel":"NewAndNoteworthies_carousel__TdLaG","caption":"NewAndNoteworthies_caption__x4aqG","banner":"NewAndNoteworthies_banner__ZafPk"};